// JavaScript Document
/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

  	
	$(document).ready(function() {
		if ((typeof Shopify) === 'undefined') {
		  Shopify = {};
		}
		rome.init();
	});
	
	var rome = {
        romeTimeout: null,
		
		init: function() {	            
            this.banner();
            this.mobile();
            this.header();
         	this.Insta_Height();
            this.menu();
            this.grid_height();
            
            this.newsletter();	
            
           	
            this.window_resize();
            this.alert_css();
            this.heap_box();
          	this.closecartdrawer();   
            this.pre_loader(); 
            this.scrolltop();
          	this.section_script();
			this.qty();	
          
        },
		
        section_script: function(){
          
          var sections = new theme.Sections();
          sections.register('slideshow-section', rome.slideshow);
          sections.register('collection-section',rome.collection);
          sections.register('product-section',rome.product);
          sections.register('contact-map',rome.map);
       },
      
      map: function(container){
        
        var $container = this.$container = $(container);  
        var zoom_level = $container.attr('data-zoom_level');
        var scrollwheel = $container.attr('data-scrollwheel');

        if(scrollwheel == 'false'){

          var boolen_scroll = 0 ;

        }else{

          var boolen_scroll = 1 ;

        }
			
            var latlng = new google.maps.LatLng(0, 0);
            var myOptions = {
              zoom: parseInt(zoom_level),
              center: latlng,
              scrollwheel:boolen_scroll,
              scaleControl:boolen_scroll, 
              disableDefaultUI: false,
              mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map2 = new google.maps.Map(document.getElementById("map-canvas"), myOptions);

            var geocoder_map2 = new google.maps.Geocoder();
            var address = $container.attr('data-address');
            geocoder_map2.geocode( { 'address': address}, function(results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                map2.setCenter(results[0].geometry.location);

                var marker = new google.maps.Marker({
                  map: map2, 
                  position: map2.getCenter()
                });

                var contentString = $container.attr('data-address');
                var infowindow = new google.maps.InfoWindow({
                  content: contentString
                });

              } else {
                alert("Geocode was not successful for the following reason: " + status);
              }
            });

      
      },
      
      Insta_Height : function(){
        $(window).load(function(){
          $('#instafeed .insta-imges').css('height', $('.insta-imges').width());
        });
        
        $(window).resize(function() {
           $('#instafeed .insta-imges').css('height', $('.insta-imges').width());
        });
        
      },
      
      product : function(container){
        var $container = this.$container = $(container);
        
        var sectionId = $container.attr('data-section-id');
        if (!$('#ProductJson-' + sectionId).html()) {
          return;
        }
        var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
        new Shopify.OptionSelectors('productSelect', {
          product: productSingleObject,
          onVariantSelected: selectCallback,
          enableHistoryState: true
        });
        
        var option_name = productSingleObject.options[0];
        
       
        // Add label if only one product option and it isn't 'Title'. Could be 'Size'.
        if (productSingleObject.options.length == 1 && productSingleObject.options[0] != 'Title') {
          $('.selector-wrapper:eq(0)').prepend('<label for="productSelect-option-0">'+ option_name +'</label>');
        }

        // Hide selectors if we only have 1 variant and its title contains 'Default'.
        if (productSingleObject.variants.length == 1 && productSingleObject.variants[0].title.toLowerCase().indexOf('default') !== -1) {
          $('.selector-wrapper').hide();
        }
        
          jQuery(function() {
          jQuery('.swatch :radio').change(function() {
            var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
            var optionValue = jQuery(this).val();
            jQuery(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
          });
        });
        
        $('.swatch').each(function() {
              var index = $(this).data('option-index');
              $('.selector-wrapper:eq('+index+')').hide();
            });
         
          $("#AddToCart").click(function(e){
            var form = $(this).closest('form');
            rome.quickviewAjaxAddToCart(form);
            e.preventDefault();
          });
         
      	rome.product_slider();
        rome.jQueryUi();
        if($container.attr('data-review') == 'true'){
         //return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
        }
      },
      
      quickviewAjaxAddToCart:function(form){
        $.ajax({
          type: "post",
          url: "/cart/add.js",
          data: jQuery(form).serialize(),
          dataType: 'json',
          beforeSend: function() {
           
          },
          success: function(msg) { 
           	  rome.quickviewUpdateCart();
             },
             error: function(xhr, text) {
               
              $(form).find("#AddToCart").val("Add to Cart");
              var data = eval('(' + xhr.responseText + ')');
              $('#AddToCartForm').next().after('<div class="errors qty-error">'+ data.description +'</div>');

              window.setTimeout(function() {
                $(".errors.qty-error").fadeOut();
              }, 2000);
            }
          });
        },

      quickviewUpdateCart:function(){
          	jQuery.getJSON('/cart.js', function (cart, textStatus) {
                ajaxCart.load();
            });      
        
        },
      
      collection : function(container){
        
         var $container = this.$container = $(container);
        
      	 if($container.attr('data-filter') == 'true'){
        	rome.collectionFilter();
            rome.toggle();
            rome.grid_height();
			rome.widthResizeContent();
         }
          if($container.attr('data-sort_by') == 'true'){
            rome.sidebarMapSorting();
            rome.sidebarParams();  
          }
        
       
        
        if($(".quick_view_list").length > 0){
          rome.product_listing();
          
         
          //return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
        }
        
      
       
      },
     
      qty : function(){
      
      	 $( "body" ).on( "click", ".plus", function(e) {
              var getPval = $(this).next().val();
              var getPval = parseInt(getPval) + parseInt(1);
              $(this).next().val(getPval);
              $("#update-cart").trigger('click');
            });
          	
          	$( "body" ).on( "click", ".minus", function(e) {
              var getMval = $(this).prev().val();
			  var getMval = parseInt(getMval) - parseInt(1);
              if(getMval){
                $(this).prev().val(getMval)
              }
              $("#update-cart").trigger('click');
            });
       },
      
     
      slideshow : function(container){
        
          var $container = this.$container = $(container);
    	  var id = $container.attr('data-section-id');
          var transition = $container.attr('data-transition');
          if($container.attr('data-autoplay') == 'true'){
            var autoplay = true;
          }
          else{
            var autoplay = false;
          }
            
          var speed = $container.attr('data-speed');
          
          if($container.attr('data-show-dots') == 'true'){
            var show_dots = true;
          }
          else{
            var show_dots = false;
          }
          if($container.attr('data-show-nav') == 'true'){
            var show_nav = true;
          }
          else{
            var show_nav = false;
          }
          
          if(transition == 'horizontal'){
          	var Loop_new = false;
		  }
          else{
          	var Loop_new = true;
          }
          
          //=============== SLIDER    =======          
          $('.'+ id).find('.bxslider').bxSlider({
            mode: $container.attr('data-transition'),
            captions: true,
            auto:autoplay,
            controls: show_nav,
            pager: show_dots,
            pause: $container.attr('data-speed'),
            infiniteLoop: Loop_new,
            onSliderLoad: function() {
               $('.'+ id).find('.bxslider > li').not('.bxslider > li.bx-clone').eq(0).addClass('active');
            },
            onSlideBefore: function() {},
            onSlideAfter: function(currentSlideNumber, totalSlideQty, currentSlideHtmlObject) {
              $('.'+ id).find('.bxslider > li.active').removeClass('active');
              $('.'+ id).find('.bxslider > li').not('.bxslider > li.bx-clone').eq(currentSlideHtmlObject).addClass('active');
			}
            
          });
          
         
       },
      
       pre_loader : function(){

          $(window).on('load', function() { // makes sure the whole site is loaded 
            $('#status').fadeOut(); // will first fade out the loading animation 
            $('#preloader').delay(350).fadeOut('slow'); // will fade out the white DIV that covers the website. 
            $('body').delay(350).css({'overflow':'visible'});
            if($(window).width() > 1024){
            	new WOW().init({offset:10});
            }
          });
           

        },
      
      banner: function() {
			$('.cd-projects-previews li a').click(function(e) {
				$('.full').remove();
				$('.product_list .product_item').each(function(index, element) {
					$(this).removeClass('active');
				});
			});
           
    	},
	
		
		mobile:function(){
			//RESPONSIVE MENU TRIGGER
			$('header nav').meanmenu();
		},
		
		header:function(){
			// Fixed Header
			$(window).scroll(function() {
			   if ($(window).scrollTop() > 50) {
				$('header').addClass('sticky_nav');
			   } else {
				 $('header').removeClass('sticky_nav')
			   }
			}); 
			
			// Search icon click
			$('.top_search').click(function(e) {
				$('.search_overlay').addClass('pop_class');
			});
			
			// Close search popup
			$('.close').click(function(e) {
				$('.overlay').removeClass('pop_class');
			});                    
		},
		
		menu: function(){
          
			$('#nav-menu li.has-sub>a').on('click', function(){
				$(this).removeAttr('href');
				var element = $(this).parent('li');
				if (element.hasClass('open')) {
					element.removeClass('open');
					element.find('li').removeClass('open');
					element.find('ul').slideUp();
				}
				else {
					element.addClass('open');
					element.children('ul').slideDown();
					element.siblings('li').children('ul').slideUp();
					element.siblings('li').removeClass('open');
					element.siblings('li').find('li').removeClass('open');
					element.siblings('li').find('ul').slideUp();
				}
			});
		
			$('#nav-menu>ul>li.has-sub>a').append('<span class="dwn-arrow"></span>');
			$('#nav-menu>ul>li>ul>li.has-sub>a').append('<span class="dwn-arrow"></span>');
			
		},
		
        showLoading: function() {
            $('.loading-modal').show();
        },
		
        hideLoading: function() {
            $('.loading-modal').hide();
        },
		
		product_slider: function(checkset){
			/*$('.featured-img').bxSlider({
			  pagerCustom: '#thumb'
			});*/
          	
          	$(".thumb-product").owlCarousel({
                loop:false,
              //  rewindNav:true,
                nav:($('#thumb').children().length < 5) ? false : true,
              	dots:false,
                margin: 15,
                responsive:{
                    0:{
                      items:3
                    },
                    481:{
                      items:5
                    },
                    768:{
                      items:4
                    },                    
                }         
            });         
          

            // Custom Navigation Events
            $(".next").click(function(){
              owl.trigger('owl.next');
            })
            $(".prev").click(function(){
              owl.trigger('owl.prev');
            })
          
			$('#thumb > div a').each(function(index, element) {				
                $(this).click(function(e) {   
                  	var get_img = $(this).data("image"); 
                    $('.featured-img img').attr('src',get_img);
                    $('.featured-img img').fadeOut('fast',function(){
                      $('.featured-img img').attr('src',get_img).fadeIn('fast');
                    });                     
                });
            });
          
          
            $(".full_page_list .product_list_slider").owlCarousel({
              loop:false,
              nav:false,
              dots:true,
              margin:30,
              responsive:{
                0:{
                  items:2,
                  margin:5,
                },
                480:{
                  items:2,
                  margin:5,
                },
                481:{
                  items:3,
                  margin:15,
                },
                540:{
                  items:3,
                  margin:12,
                },
                768:{
                  items:3,
                  margin:15,
                },
                991:{
                  items:4,
                  loop:true,
                },
                1024:{
                  items:4,
                  loop:false,
                  dots:false,
                },
                1025:{
                  items:4,
                  loop:false,
                  dots:false,
                }
              }
            });
          
          
            $(".related-product > .grid").owlCarousel({
              loop:false,
              nav:false,
              dots:true,
              margin:30,
              responsive:{
                0:{
                  items:1,
                  margin:0,
                },
                481:{
                  items:2,
                  margin:15,
                },
                768:{
                  items:3,
                  margin:15,
                },
                991:{
                  items:4,
                  dots:false,
                },
                1024:{
                  items:4,
                  dots:false,
                },
                1025:{
                  items:4,
                  dots:false,
                }
              }
            });
            
		},

        
        grid_height: function(){	
           //============================== PRODUCT LIST IMG HEIGHT                     
           $('.product_item .product_img').responsiveEqualHeightGrid(); 
           $('.product_item .product_name a').responsiveEqualHeightGrid();
           $('.blog_item_list .blog_info').responsiveEqualHeightGrid();
		},  
      
       
		createQuickViewVariants: function(product, quickview){
			if (product.variants.length > 0) { 
              	//multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                   quickview.find('form.variants > select').append(option);
                }
                
                new Shopify.OptionSelectors("productSelect", {
                    product: product,
                    onVariantSelected: selectCallback
                });

                if(product.variants[0].title == "Default Title"){
					$('.selector-wrapper:eq(0)').hide();
                }
                if (product.options.length == 1) {                  
                  $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
                  for (var text = product.variants, r = 0; r < text.length; r++ ) {
                    var s = text[r];                    
                  };
                }
              
                quickview.find('form.variants .selector-wrapper label').each(function(i, v) {
                    $(this).html(product.options[i].name);
                });
            } else { //single variant
              	$("#productSelect").hide();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickview.find('form.variants').append(variant_field);
            }
		},

		convertToSlug: function(text) {
            return text
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
        },

		createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
            if (product.variants.length > 0) { //multiple variants                
                var options = "";
                for (var i = 0; i < product.options.length; i++) {
                	var is_color = false;
                    if (/Color|Colour/i.test(product.options[i].name)) {
                        is_color = true;
                    }

                    if(is_color){
                    	$('.selector-wrapper:eq('+i+')').hide();
	                    options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                      options += '<div class="header">' + product.options[i].name + ' : </div>';                                        
	                    
	                    var optionValues = new Array();
	                    for (var j = 0; j < product.variants.length; j++) {
	                        var variant = product.variants[j];                  
	                        var value = variant.options[i];
	                        var valueHandle = this.convertToSlug(value);
	                        var forText = 'swatch-' + i + '-' + valueHandle;
	                        if (optionValues.indexOf(value) < 0) {
	                            //not yet inserted
	                            options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + '">';

	                            if (is_color) {
	                                options += '<div class="tooltip">' + value + '</div>';
	                            }
	                            options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + ' />';

	                            if (is_color) {
	                                options += '<label for="' + forText + '" ><span style="background-color: ' + valueHandle + '; background-image: url(' + valueHandle + '.png)"></span></label>';
	                            } else {
	                                options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="soldout.png" /></label>';
	                            }
	                            options += '</div>';
	                            if (variant.available) {
	                                $('.product-template .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
	                            }
	                            optionValues.push(value);
	                        }
	                    }
	                    options += '</div>';
                    }
                }
                quickviewTemplate.find('form.variants > select').after(options);
                quickviewTemplate.find('.swatch :radio').change(function() {
                    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                    var optionValue = $(this).val();
                    $(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');
                });
                if (product.available) {
                    Shopify.optionsMap = {};
                    //Shopify.linkOptionSelectors(product);
                }

                //end of quickview variant
            } else { //single variant
                quickviewTemplate.find('form.variants > select').html("");
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }
        },

		product_listing: function() {	          
			if($(window).width() > 1024){           
              	//stopPropagation();
              	
                var $template = $('#product-detail').html();
				$('.product-template').after('<div class="product-template grid__item product-template-new">'+ $template +'</div>');
				var $template_new = $('.product-template-new');
				
                
                
				var $gall = $('.product_list'),
				$div  = $gall.find("> .product_item"),
				$full = $("<div />", {"class":"full grid__item", html:$template_new});
				


				$div.attr("data-id", function(i, v){
					//console.log(v);
				}).on("click", function(evt){	
               		evt.preventDefault(); 
                    rome.showLoading();

                    setTimeout(function(){
                      rome.hideLoading();
                    },1000);

                   //get handle of product
					var pro_handle = $(this).attr("data-id");
                    var pro_url = $(this).attr("data-url");
                  
					//get prodct detail
					Shopify.getProduct(pro_handle, function(product) {  
			            var quickview = $('.product-template-new');

			            //product title
			            quickview.find('.product_title').html((product.title));
                      	
                        // product link
						quickview.find('p.view-full-product a').attr('href', pro_url);
	                    
	                    //product description
	                    if (product.description.length > 0) {
                           var shortText = jQuery.trim(product.description).split(" ").slice(0, 50).join(" ") + "...";
         				   quickview.find('.product_info').html(shortText);
	                    }else{
	                    	quickview.find('.product_info').html("");
	                    }

	                    //product price
	                    quickview.find('#ProductPrice').html(Shopify.formatMoney(product.price, window.money_format));

	                    //if has compare price
	                    if (product.compare_at_price > product.price) {
	                        quickview.find('#compare_price_preview').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
	                        //quickview.find('.price').addClass('on-sale');
	                    } else {
	                        quickview.find('#compare_price_preview').html('');
	                        //quickview.find('.price').removeClass('on-sale');
	                    }

	                    //avarage review
		                quickview.find(".shopify-product-reviews-badge").attr('data-id',product.id);

	                    //product images
	                    var pro_image = Shopify.resizeImage(product.featured_image, '1024x1024');
	                    if(pro_image == null){
	                    	var pro_image = "//cdn.shopify.com/s/assets/admin/no-image-large-1cfae84eca4ba66892099dcd26e604f5801fdadb3693bc9977f476aa160931ac.gif";
	                    }
	                    quickview.find('ul.featured-img li img').attr('src', pro_image);
                        quickview.find('ul.featured-img li img').attr('alt', product.title);	

                        Shopify.Image.preload(product.images, '1024x1024');
                        

                      if(product.images.length > 1){
                      //thumbnails
                      	$(".full #thumb").remove();
                        $('.featured-img').after('<div id="thumb" ></div>');
                      	var quickViewCarousel = quickview.find('#thumb');
                        
                        
	                    //quickViewCarousel.html("");
	                    var count = 0;
		                for (i in product.images) {
		                    if (count < product.images.length) {
		                        var large = Shopify.resizeImage(product.images[i], '1024x1024');
		                        var compact = Shopify.resizeImage(product.images[i], 'compact');
                              
								var item = '<a href="javascript:void(0);" data-image="'+ large +'" data-slide-index="'+ count +'"><img src="' + compact + '" alt="'+ product.title +'"/></a>'                        

		                        quickViewCarousel.append(item);
		                        count = count + 1;
		                    }
		                }

                      }
		                //variant empty
		                $('form.variants > select').html("");
		                quickview.find('form.variants .selector-wrapper').each(function(i, v) {
			                $(this).remove();	
			            });
			            quickview.find('form.variants .swatch.clearfix').each(function(i, v) {
			                $(this).remove();	
			            });
		                
		                //variant swatch
		                rome.createQuickViewVariants(product, quickview);
		                rome.createQuickViewVariantsSwatch(product, quickview);		                

		                //social share
		                var permalinkURL = "http://"+window.location.hostname+product.url;
		                var shareTitle = product.title;

		                quickview.find(".Share-facebook").attr("href","//www.facebook.com/sharer.php?u="+permalinkURL);
		                quickview.find(".Share-twitter").attr('href','//twitter.com/share?url='+permalinkURL+'&amp;text='+shareTitle);
		                quickview.find(".Share-instagram").attr("href",'http://www.linkedin.com/shareArticle?mini=true&url='+permalinkURL+'&title='+shareTitle+'&source=[SOURCE/DOMAIN]');
		                quickview.find(".Share-pinterest").attr("href",'//pinterest.com/pin/create/button/?url='+permalinkURL+'&amp;description='+shareTitle);
						//rome.product_slider();
                        $(".full #thumb").owlCarousel({
                            loop:false,
                            nav:($('#thumb').children().length < 5) ? false : true,
                            dots:false,
                            margin: 15,
                            responsive:{
                                0:{
                                  items:4
                                },
                                481:{
                                  items:6
                                },
                                768:{
                                  items:5
                                },
                                993:{
                                  items:4,
                                },
                                1024:{
                                  items:4,
                                },
                                1025:{
                                  items:4,
                                }
                            }
                        });                      
                        $('#thumb > div a').each(function(index, element) {				
                            $(this).click(function(e) {   
                                var get_img = $(this).data("image"); 
                                $('.featured-img img').attr('src',get_img);
                                $('.featured-img img').fadeOut('fast',function(){
                                  $('.featured-img img').attr('src',get_img).fadeIn('fast');
                                });                     
                            });
                        });
                      
						//rome.viewmoreproduct();
						$('.close-preview').click(function(e) {							
							var $el = $(this), $clone = $full.clone();
							$div.removeClass("active");
							$template.hide();
							$full.after($clone);
							$clone.find(">div").slideUp('slow',function(){
								$clone.remove();
							});
						});
					});

					var $el = $(this), $clone = $full.clone();
					$el.toggleClass("active");
					$el.siblings().removeClass("active");
					
					$template_new.hide();
					$full.after($clone);

					$clone.find(">div").slideUp(function(){
						$clone.remove();
					});

					if(!$el.hasClass("active")) return;

					$(this).parent().find('> div').filter(function(i, el){
						return el.getBoundingClientRect().top < evt.clientY;
					}).last().after($full);
                  
                  	
					
					$('#quantity').val('1');
                  
                   
                      rome.product_slider();
                      $template_new.slideDown();
					
					setTimeout( function(){
						var position = $el.offset().top,
						previewOffsetT = $full.offset().top,
						scrollVal = $full.find('.product-template').outerHeight(false) + $el.outerHeight(true) + 0 <= $(window).height() ? position : $full.find('.product-template').outerHeight(false) < $(window).height() ? previewOffsetT - ( $(window).height() - $full.find('.product-template').outerHeight(false) ) : previewOffsetT;
						$('body,html').animate( { scrollTop : scrollVal }, 350 );
					},500);
					
					$('.close-preview').click(function(e) {						
						var $el = $(this), $clone = $full.clone();
						$div.removeClass("active");
						$template_new.hide();
						$full.after($clone);
						$clone.find(">div").slideUp('slow',function(){
							$clone.remove();
						});
					});
                   
                  $("#AddToCart").click(function(e){
                    e.preventDefault();
                    var form = $(this).closest('form');
                    rome.quickviewAjaxAddToCart(form);
                  });
                  

				});
				
              	$(window).on("resize", function(){
					$full.remove();
					$div.removeClass("active");
				});
			};
			
		},

		viewmoreproduct: function(){
			var currentList = $('.block-row .product_list');

			$(".load-more-product.viewmore a").click(function(e) {
				e.preventDefault();
				if (currentList) {
					var viewMoreButton = $('.load-more-product a').first();
					$.ajax({
	                    type: 'GET',
	                    url: viewMoreButton.attr("href"),	                    
	                    success: function(data) {
	                        var products = $(data).find(".block-row .product_list");
	                        if (!products.length) {
	                            products = $(data).find(".block-row .product-list");
	                        }
	                        if (products.length) {	                            
	                            currentList.append(products.children());
	                            
	                            //get link of Show more
	                            if ($(data).find('.load-more-product a').length > 0) {
	                                viewMoreButton.attr('href', $(data).find('.load-more-product a').attr('href'));
	                            } else {
	                                //no more products
	                                viewMoreButton.hide();
	                                viewMoreButton.next().show();
	                            }
	                          	
	                        }
	                        rome.product_listing();
	                      
	                    },
	                    error: function(xhr, text) {
	                        //t.hideLoading();
	                        //$('.loading-modal').hide();
	                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
	                        //t.showModal('.ajax-error-modal');
	                    },
	                    dataType: "html"
	                });
				}
			});
		},

		jQueryUi: function(){
			$( "#Product-tabs" ).tabs();
		},
		
		newsletter: function(){
			$(window).load(function(){
   				setTimeout( function() {
				  var check_cookie = $.cookie('mailing_list_popup');
				  
				  $('.newsletter_popup .close_btn').click(function(e) {
					$.cookie('mailing_list_popup', '1', { expires: 31 });
				  	$(".newsletter_overlay").removeClass('newsletter_popupactive');
				  });
				  
				  if(check_cookie == null){
					$.cookie('mailing_list_popup', '1', { expires: 31 });
					$(".newsletter_overlay").addClass('newsletter_popupactive');
				  }
				  else if(check_cookie < 1){
					x = $.cookie('mailing_list_popup');
					y = 1;
					var z = +x + +y;
					$.cookie('mailing_list_popup', z, { expires: 31 });
					  $(".newsletter_overlay").addClass('newsletter_popupactive');
				  }
				}, 4000);
			}); 
		},

      	window_resize: function(){
			$(window).load(function(){
				rome.resizeContent();   
					
				$(window).resize(function() {
					rome.resizeContent();
                  	rome.widthResizeContent();
                  	
                  
				});
              
                $(window).on("orientationchange",function(){
                  rome.collectionFilter();
                });
			});

		},
		
		resizeContent: function(){
			height_screen = $(window).height();
			$('#error_banner').height(height_screen);
		},
      
      	alert_css: function(){
          //------ alert css -----------
			window.alert = function(message) { $('#messageBox').text(message).fadeIn().delay(4000).fadeOut('slow'); }
        },
      
		toggle: function(){
			$(".filter_btn .openFilter").click(function(e){
			    e.preventDefault();
				$('.filter_open').toggleClass('active-filter');
			});	 
          
          	$('html').click(function() {
              $('.filter_open').removeClass('active-filter');
            });
          	$('.filter_btn .openFilter,.filter_open,.filter_tag_list').click(function(event){
              event.stopPropagation();
            });
          	
          	$(".filter-col-size").click(function(){
				$(".filter_open").removeClass('active-filter');
            });
         
		},
      	
        heap_box: function(){
     		$(".sort_by").heapbox();          	
        },
      
      	widthResizeContent: function() {
            width_screen = $(window).width();          
            if(width_screen < "991"){  
              $( "#mobile_filter" ).tabs().addClass( "ui-tabs-vertical ui-helper-clearfix" );
              $( "#mobile_filter li" ).removeClass( "ui-corner-top" ).addClass( "ui-corner-left" );
              $("#mobile_filter .tag-filter ul").removeClass("sidebar-tag");            
            }else{              
              $( "#mobile_filter" ).tabs();
              $('#mobile_filter').tabs('destroy');
              $("#mobile_filter .tag-filter ul").addClass("sidebar-tag"); 
            }          
        },
      
      	// collection filter 
        collectionFilter: function(){   
          rome.sidebarParams();  
          rome.sidebarMapPaging();
          rome.sidebarMapEvents();
          if ($(".filter_open").length > 0) { 
            rome.getCurrentTag();          
            rome.sidebarMapClear();
            rome.sidebarMapClearAll();
          }
          
        },
      
        sidebarParams: function() {
           Shopify.queryParams = {};
           //get after ?...=> Object {q: "Acme"} 
           if (location.search.length) {
             for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
               aKeyValue = aCouples[i].split('=');
               if (aKeyValue.length > 1) {
                 Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
               }
             }
           }
        },
      
       sidebarMapEvents: function() {
           rome.sidebarMapTagEvents();
      },
      
       sidebarMapPaging: function() {
            $(".collection-paginate .pagination a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if(page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = rome.sidebarCreateUrl();
                        rome.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        rome.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            'scrollTop': 0
                        }, 500);
                    }
                }
                e.preventDefault();
            });
       },
         
       sidebarMapClear: function() {            
            $(".filter_open .tag-filter ul,.sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if(sidebarTag.find("input:checked").length > 0) {                  
                    $('span.clear-all').show();
                    //has active tag
                    sidebarTag.find(".clear").css("display","block").click(function(e) {
                        var currentTags = [];
                        if(Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if(tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if(currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
                        rome.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
       },  
         
       sidebarMapClearAll: function() {
            //clear all selection
             $('.clear-all').click(function(e) {               	 
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;                
              	rome.sidebarAjaxClick();
               	$(".filter_tag").hide();
                e.preventDefault();    
                $(".filter_open").removeClass('active-filter');
            });
       },	   
         
       sidebarMapTagEvents: function() {            
            $('.sidebar-tag a:not(".clear"), .sidebar-tag li').click(function(e) {

                var currentTags = [];
                var check_radio =  $(this).find("input").attr("type");
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }
                if(check_radio == "radio"){                 
                //one selection or multi selection                
                    if (!window.enable_sidebar_multiple_choice && !$(this).find("input").is(":checked")) {
                        //remove other selection first
                        var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                        if (otherTag.length > 0) {
                            var tagName = otherTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        }
                    }
                }

                var tagName = $(this).find("input").val(); 
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName); 
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                     $(".filter_tag").show();
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
					 $(".filter_tag").hide();
                    delete Shopify.queryParams.constraint;
                }
                rome.sidebarAjaxClick();
                e.preventDefault();
            });
       },
          
       getCurrentTag: function() {
          	$(".filter_tag_list").empty();
          	$(".filter_open .tag-filter ul").each(function(index, element){              
               $('li',this).each(function(index, element) {                 
				  $("input:checked", this).each(function(index, element) {                    
                 	var current_tag_val = $(this).val();   
                    var current_tag_name = $(this).next().text();
                	$(".filter_tag_list").append("<span value='"+ current_tag_val +"'>"+ current_tag_name +"</span>" );
                  });
               });               
            });
            $(".filter_tag_list").append(' <span class="clear-all"> Clear All </span>' );
         	
          
            $(".filter_tag_list span , .apply_filter").click(function(e) {  
             	var currentTags = [];
               	var remove_tag = $(this).attr("value");
                $(".filter_open .tag-filter ul").each(function(index, element){              
                  $('li',this).each(function(index, element) {                 
                    $("input:checked", this).each(function(index, element) {
                      var current_tag_val = $(this).val();

                      if(current_tag_val == remove_tag ){

                      }else{
                        currentTags.push($(this).val()); 
                      }
                    });
                  });                
                }); 
                if (currentTags.length) {
                  $(".filter_tag").show();
                  Shopify.queryParams.constraint = currentTags.join('+');
                } else {                  
                  $(".filter_tag").hide();
                  delete Shopify.queryParams.constraint;
                }

                if($(this).hasClass('apply_filter')){
                  $(".filter_open").removeClass('active-filter');
                }

              rome.sidebarAjaxClick(); 
              e.preventDefault();
            });        

       }, 
         
       sidebarMapSorting: function(e) {  
          $("#heapbox_SortBy .heapOptions a").click(function(){   
             Shopify.queryParams.sort_by = $(this).attr("rel"); 
             rome.sidebarAjaxClick();
          });
       },
         
       sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = rome.sidebarCreateUrl(baseLink);            
            rome.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            rome.sidebarGetContent(newurl);            
       },
         
       sidebarCreateUrl: function(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            
            if (newQuery != "")
              return location.pathname + "?" + newQuery;
            else
              return location.pathname + newQuery; 
       },
          
       sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    rome.showLoading();
                },
                success: function(data) {
                    rome.sidebarMapData(data);
                  	if ($(".filter_open").length > 0) { 
                  	rome.getCurrentTag();                    
                    rome.sidebarMapClear();
                    rome.sidebarMapClearAll();
                    }
                  	rome.sidebarMapPaging();
                    rome.sidebarMapTagEvents();
                  	rome.product_listing();
                    rome.hideLoading();  
                    //rome.sidebarStyle();                  
                },
                error: function(xhr, text) {
                    rome.hideLoading();
                    $('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    rome.showModal('.ajax-error-modal');
                }
            });
       },
       
       showLoading: function() {
              $('.loading-modal').show();
       },
      
       hideLoading: function() {
            $('.loading-modal').hide();
       },
        scrolltop :function(){
          $('#scrollToTop').bind("click", function () {
            $('html, body').animate({ scrollTop: 0 }, 800);
            return false;
          });
        },
      
       sidebarMapData: function(data) {                       
            var currentList = $(".block-row > .grid");
            if (currentList.length == 0) {
                currentList = $(".block-row > .grid");
            }
            var productList = $(data).find(".block-row > .grid");

            if (productList.length == 0) {
                productList = $(data).find(".block-row > .grid");
            }
            currentList.replaceWith(productList);
           
            //replace paging 
            if ($(data).find(".pagination").length > 0) {
            	$(".pagination").show();
                $(".pagination").replaceWith($(data).find(".pagination"));
            }else{
            	$(".pagination").hide();
            }

            //replace tags            
            //$(".filter_open > div").replaceWith($(data).find(".filter_open > div")); 
         	$("#mobile_filter").replaceWith($(data).find("#mobile_filter"));
         	$(".mobile_filter_header").replaceWith($(data).find(".mobile_filter_header"));
            $(".mobile_filter_footer").replaceWith($(data).find(".mobile_filter_footer"));
            if($(".mobile_filter_footer").length > 0){
               $(".filter-col-size").click(function(){
                 $(".filter_open").removeClass('active-filter');
               });
            }
         
         	//showing result paging 
            if ($(data).find(".page-total").length > 0) {
            	$(".page-total").show();
                $(".page-total").replaceWith($(data).find(".page-total"));
            }else{
            	$(".page-total").hide();
            }        
         	
         	//tabify
         	width_screen = $(window).width();          
            if(width_screen < "991"){             
          		rome.widthResizeContent(); 
			}
         
         	//product review
            //window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
         
         
        },
          
        closecartdrawer: function() {
          $('#CartDrawer').click(function(e) {
              e.stopPropagation();
          });          
        }
      	
    }



$(".main-menu > ul.menu-ul").niceScroll();
